module.exports = __webpack_public_path__ + "static/media/brasserie.09302a9e.jpg";